module.exports = __webpack_public_path__ + "assets/img/pegi-it.3c4095f3.png";